import { useEffect } from 'react'
import { useScrollIntoViewIfNeeded } from '@hooks/useScrollIntoViewIfNeeded'

import './NodeElement.css'

interface NodeElementProps {
  nodeId: string
  type: string
  title: string
  isSelected: boolean
  isEditable: boolean
  onSelect: () => void
}

export default function NodeElement({
  type,
  title,
  isSelected,
  isEditable,
  onSelect
}: NodeElementProps) {
  const elementRef = useScrollIntoViewIfNeeded<HTMLElement>(isSelected, {
    containerSelector: '#query-builder-area'
  })

  useEffect(() => {
    const el = elementRef.current
    if (!isSelected || !el) return

    const container = el.closest('#query-builder-area')
    const bounds = container
      ? container.getBoundingClientRect()
      : new DOMRect(0, 0, window.innerWidth, window.innerHeight)
    const rect = el.getBoundingClientRect()

    const fullyVisible =
      rect.top >= bounds.top &&
      rect.left >= bounds.left &&
      rect.bottom <= bounds.bottom &&
      rect.right <= bounds.right

    if (!fullyVisible) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'start'
      })
    }
  }, [elementRef, isSelected])

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    onSelect()
  }

  const variantClass = type === 'dataset' ? 'dataset' : 'operation'

  const className = [
    'node-element',
    `node-element-${variantClass}`,
    isSelected && 'selected',
    !isEditable && 'not-editable'
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <article
      ref={elementRef}
      onClick={handleClick}
      data-type={type}
      className={className}
    >
      <h2>{title}</h2>
    </article>
  )
}
